/* src/app/compliance/modals/new-folder-modal/new-folder-modal.component.scss */
/*# sourceMappingURL=new-folder-modal.component.css.map */
